<script>
/**
 * @param {File} file
 * @return {Promise<string>}
 */
const loadFile = file => {
    return new Promise(resolve => {
        const fr = new FileReader();
        fr.addEventListener('load', ({ target }) => resolve(target.result));
        fr.readAsDataURL(file);
    });
};

export default {
    props: {
        /**
         * Image source (String, File, Promise<Module>, Promise<File>)
         */
        src: {
            type: [String, File, Promise],
            default: null,
        },
    },
    data() {
        return {
            source: null,
        };
    },
    watch: {
        src: {
            handler(val) {
                if (typeof val === 'string') {
                    this.source = val;
                } else if (val instanceof Promise) {
                    val.then(data => {
                        // async import()
                        if (typeof data === 'object' && data.default) {
                            this.source = data.default;
                        } else if (typeof data === 'string') {
                            this.source = data;
                        } else if (data instanceof File) {
                            loadFile(data).then(source => (this.source = source));
                        }
                    });
                } else if (val instanceof File) {
                    loadFile(val).then(source => (this.source = source));
                }
            },
            immediate: true,
        },
    },
    render(h) {
        const { source } = this;
        return source ? h('img', { attrs: { src: source } }) : this.$slots.default;
    },
};
</script>
